import moment from 'moment';
import { getHoursMinutesFormat, getDifferentialPressureUnitSuffix, getUserPreferencesManager, getDifferentialPressureDecimals } from 'services/utils';

export default {
    chart: {
        type: 'line',
        get marginLeft() {
            return getUserPreferencesManager().useInchesOfWater ? 96 : 68;
        }
    },
    yAxis: [
        {
            allowDecimals: true,
            get minTickInterval() {
                return 10 ** -getDifferentialPressureDecimals();
            },
            tickPixelInterval: 32,
            labels: {
                get format() {
                    return `{value} ${getDifferentialPressureUnitSuffix()}`;
                }
            },
        },
        {
            visible: false
        }
    ],
    xAxis: {
        minTickInterval: 30000, // 30 seconds
    },
    boost: {
        enabled: false
    },
    tooltip: {
        enabled: true,
        followPointer: true,
        outside: true,
        shadow: false,
        animation: false,
        hideDelay: 100,
        borderRadius: 12,
        padding: 10,
        shared: true,
        useHTML: true,
        formatter() {
            const momentFormat = `${getHoursMinutesFormat()} ddd, MMM D`;
            const unit = getDifferentialPressureUnitSuffix();
            const decimals = getDifferentialPressureDecimals();
            const timestamp = moment(this.x).format(momentFormat);
            let tooltipHtml = `
                <p style="font-weight:bold; color: white; text-align: center; width: 100%; margin-top: 2px; margin-bottom: 6px;">
                    ${timestamp}
                </p>`

            // Get min/max/avg temperature values to determine which tooltip variant to show
            let min = null
            let max = null
            let avgOrRaw = null // avg if min/max is present, raw if not

            this.points.forEach(function(entry) {
                if (entry.series.name === 'Differential pressure') {
                    avgOrRaw = entry.y.toFixed(decimals);
                }
                if (entry.series.name === 'Min/Max') {
                    min = entry.point.low.toFixed(decimals);
                    max = entry.point.high.toFixed(decimals);
                }
            })
            tooltipHtml += "<table>"
            if (min !== null && max !== null) {
                tooltipHtml += `
                <tr>
                    <td style="color: white; padding-right: 36px;">
                        Max
                    </td>
                    <td style="font-weight:bold; text-align: right; color: white">
                        ${max} ${unit}
                    </td>
                </tr>
                <tr>
                    <td style="color: white; padding-right: 36px;">
                        Avg
                    </td>
                    <td style="font-weight:bold; text-align: right; color: white">
                        ${avgOrRaw} ${unit}
                    </td>
                </tr>
                <tr>
                    <td style="color: white; padding-right: 36px;">
                        Min
                    </td>
                    <td style="font-weight:bold; text-align: right; color: white">
                        ${min} ${unit}
                    </td>
                </tr>`
            } else {
                tooltipHtml += `
                <tr>
                    <td style="color: white; padding-right: 12px;">
                        Differential pressure
                    </td>
                    <td style="font-weight:bold; text-align: right; color: white">
                        ${avgOrRaw} ${unit}
                    </td>
                </tr>`
            }
            
            tooltipHtml += "</table>";
            return tooltipHtml;
        }
    },
    plotOptions: {
        line: {
            connectNulls: true,
            getExtremesFromAll: false,
            marker: {
                radius: 3
            }
        }
    }
};
